export const HorarioConfig = {
    inicio: 10, // Hora de inicio (08:00)
    fin: 20,   // Hora de fin (17:59)
};

export const DireccionConfig = {
    direccion: "F956+P23 Vikingos BarberShop, Comayagua",
    longitud: -87.63994973497019,
    latitud: 14.459289264262981,
};

export const NegocioConfig = {
    sistema: "SIGAIN",
    nombre: "SISTEMA DE CONTROL",
    rtn: "03019008133040",
    direccion: "Comayagua, Vikingos BarberShop",
    telefono: "3341-7291",
    imagen:"/logoPrincipal.png"
};